import Content from './content'
import Galleries from './galleries'

const FacilitesList = ({ facilitiesList }) => {
  const base = 'relative w-full flex flex-col gap-y-largeDesktop mt-largeMobile lg:mt-largeDesktop mb-largeMobile lg:mb-mediumDesktop'

  return (
    <div className={base}>
      {facilitiesList.map((data, id) => (
        <section
          id={data.identifier.current}
          key={id}
          className="relative w-full"
        >
          <Galleries galleries={data.galleries} />
          <Content
            title={data.title}
            description={data.description}
            icon={data.icon}
            ctaButton={data.ctaButton}
            points={data.points}
          />
        </section>
      ))}
    </div>
  )
}

export default FacilitesList
